import Loader from '@/components/Loader';
import PropTypes from 'prop-types';
import './ProgressBar.scss';

const ProgressBar = ({ progress = null, size = 'lg' }) => {
   return (
      <div className="progress-ring-loader-wrapper ct-flexCenter">
         <Loader size={size} variant="progress" progress={progress} />
      </div>
   );
};

ProgressBar.propTypes = {
   progress: PropTypes.number,
   size: PropTypes.string,
};

export default ProgressBar;
